import consola from 'consola'
export default defineNuxtPlugin((nuxtApp) => {
  if (!process.client) {
    return
  }

  nuxtApp.hook('app:mounted', async () => {
    try {
      const [{ Capacitor }, statusBarModule] = await Promise.all([
        import('@capacitor/core'),
        import('@capacitor/status-bar'),
      ])

      if (!Capacitor.isNativePlatform()) {
        return
      }

      const { StatusBar } = statusBarModule

      await StatusBar.setOverlaysWebView({ overlay: true })
    } catch (error) {
      consola.warn('[status-bar] Не удалось настроить StatusBar', error)
    }
  })
})

